import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import ReactGA from 'react-ga';
import * as BranchSDK from 'branch-sdk';
import clevertap from 'clevertap-web-sdk';
import { datadogRum } from '@datadog/browser-rum';

import * as serviceWorker from './serviceWorker';

import { App } from './App';

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    // dev code
} else {
    // production code

    Sentry.init({
        dsn: process.env.REACT_APP_SENTRY_KEY,
        release: process.env.REACT_APP_RELEASE,
        environment: process.env.REACT_APP_ENV,
    });
}

if (process.env.REACT_APP_CLEVER_TAP_ACCOUNT_ID) {
    clevertap.privacy.push({ optOut: false });
    clevertap.privacy.push({ useIP: false });
    clevertap.init(process.env.REACT_APP_CLEVER_TAP_ACCOUNT_ID, 'us1');
    clevertap.enablePersonalization = true;
    clevertap.spa = true;
}

if (process.env.REACT_APP_GA_TRACKING_ID) {
    if (window._DATADOG_SYNTHETICS_BROWSER === undefined) {
        ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);
    }
}

if (process.env.REACT_APP_DDRUM_CLIENT_TOKEN) {
    datadogRum.init({
        applicationId: process.env.REACT_APP_DDRUM_APP_ID,
        clientToken: process.env.REACT_APP_DDRUM_CLIENT_TOKEN,
        site: 'datadoghq.com',
        service: 'member-web',
        env: process.env.REACT_APP_ENV,
        // Specify a version number to identify the deployed version of your application in Datadog
        // version: '1.0.0',
        sampleRate: 100,
        trackInteractions: true,
    });
}

// this is really messy right now
// TODO: create method to handle branchio in navigation service
// and add unit tests for each link
const handleBranchio = (err, data) => {
    /**
     * BranchSDK.init callback. Redirect Branch.io deeplinks to the correct route and resource.
     */
    if (err) {
        return;
    }

    if (!data?.data_parsed && data?.data_parsed['+clicked_branch_link']) return;

    // Redirect dynamic Branch.io deeplinks to the correct resource
    if (data.data_parsed?.session) {
        if (data.data_parsed['~referring_link']?.includes('video-session')) {
            let videoSession = data?.data_parsed?.session;
            if (videoSession) {
                if (videoSession.includes('&')) {
                    videoSession = videoSession.split('&')[1];
                }
                window.location.replace(`video-session/${videoSession}`);
            }
        }
    } else if (data.data_parsed['~referring_link']?.includes('set-new-password')) {
        const uidb64 = data?.data_parsed?.id;
        const token = data?.data_parsed?.token;
        if (uidb64 && token) {
            window.location.replace(`/set-new-password/${uidb64}/${token}`);
        }
    }
    return;
};

BranchSDK.init('key_live_eeG21OeLi3K2tT0o2LYByeonzypSsER0', { retries: 2 }, handleBranchio);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
